<script setup lang="ts">
  import { useProductZoning } from "./useProductZoning";
  import { default as ProductZoningList } from "./ProductZoningList.vue";
  import { default as ProductZone } from "./ProductZone.vue";

  const emit = defineEmits<{ (e: "close"): void }>();

  const { selectedShopZone, shopDepartmentList, normalizedZones } = useProductZoning();

  const handleBack = (id: string) => {
    selectedShopZone.value = normalizedZones.value.byId[id];
  };
</script>

<template>
  <div class="widget__product-zoning" data-testid="widget-product-zoning">
    <ProductZone
      v-if="selectedShopZone?.parentId"
      :shopZone="selectedShopZone"
      @click:back="handleBack"
      @click:zone="selectedShopZone = $event"
    />
    <ProductZoningList
      v-else
      :shopDepartmentList="shopDepartmentList"
      :selectedShopZone="selectedShopZone"
      @click:back="emit('close')"
      @click:zone="selectedShopZone = $event"
    />
  </div>
</template>

<style scoped>
  .widget__product-zoning {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    background-color: var(--sf-base-background-primary);
    z-index: 1;
  }
</style>
